import "./Notifications.scss"
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import * as ucpActions from "../../../../store/UnifiedControlPlaneSlice";
import { FailureMessageIcon, SuccessMessageIcon, CloseSvg } from "../../assets/icons/Icons";

const Notifications = () => {
    const dispatch = useDispatch()

    const notification = useSelector(state => state.unifiedControlPlane.notification)

    useEffect(() => {
        if ((notification.isError || notification.isSuccess) &&
            (!notification.isGenerating)) {
            const timer = setTimeout(() => {
                dispatch(ucpActions.clearNotification());
            }, 4000);
            return () => clearTimeout(timer);
        }
    }, [notification, dispatch]);

    const closeNotification = () => {
        dispatch(ucpActions.clearNotification());
    };

    return (
        <div className={`notificationsSection ${notification.isError && `errorMessageDiv`}`}>
            {notification.isSuccess && !notification.isGenerating && !notification.isGenerated && <SuccessMessageIcon />}

            {/* If we want to show the success(tick) icon for scehdule generated message */}
            {/* {notification.isSuccess && notification.isGenerated && <SuccessMessageIcon />} */}

            {notification.isError && !notification.isGenerating && <FailureMessageIcon />}
            {/* not showing spinner for any text but will be useful in future */}
            {/* {notification.isGenerating && <div className="loadingSpinner"></div>} */}

            {notification.isSuccess && <span className={`${`successMessage`}`}> {notification.message} </span>}
            {notification.isError && <span className={`${`errorMessage`}`}> {notification.message} </span>}

            {(notification.isGenerating) &&
                <div className="closeIcon" onClick={closeNotification}>
                    <CloseSvg />
                </div>
            }
        </div>
    );
};

export default Notifications;